module.exports = __webpack_public_path__ + "img/175-rapa-nui.616af113.svg";